<script setup lang="ts">
  defineOptions({ name: 'EmCardTitle' })
</script>

<template>
  <div class="emerald-card__title">
    <slot />
  </div>
</template>
